import React, { Component } from 'react'
import Header from '../common/Header'
import Footer from '../common/Footer'
import Sliders from '../common/Sliders'

// import { ReactGoogleReviews } from "react-google-reviews";
// import "react-google-reviews/dist/index.css";


class Contact extends Component {

  state = {
    username: '',
    password: '',
    type: '',
    info: '',
    load: false,
    showMsg: false
  }

   render() {
    const featurableWidgetId = "2bf26bc7-64b6-4658-bc8d-96954fd5872e"
    return (
      <>
        <body>
          {<Header />}

          <div class="homepage4-body">
            <div class="vl-offcanvas">
              <div class="vl-offcanvas-wrapper">
                <div class="vl-offcanvas-header d-flex justify-content-between align-items-center mb-90">
                  <div class="vl-offcanvas-logo">
                    <a href="/"><img src="assets/img/logo/rehabLogo.png" alt="" /></a>
                  </div>
                  <div class="vl-offcanvas-close">
                    <button class="vl-offcanvas-close-toggle"><i class="fa-solid fa-xmark"></i></button>
                  </div>
                </div>

                <div class="vl-offcanvas-menu d-lg-none mb-40">
                  <nav></nav>
                </div>
                <div class="space20"></div>

                <div class="vl-offcanvas-info">

                  <div class="btn-area1">

                    <div class="btn-area1">
                      <a href="https://wa.me/256755260852" target='_blank' class="vl-btn7"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <g clip-path="url(#clip0_5832_90599)">
                          <path d="M4.32688 1.17695C4.79912 1.27456 5.1752 1.59185 5.40887 2.01104L6.15321 3.34641C6.42738 3.83825 6.65811 4.25215 6.80878 4.61195C6.96862 4.99364 7.06355 5.37002 7.02016 5.78615C6.97676 6.20229 6.80622 6.55099 6.57107 6.89148C6.3494 7.21245 6.03823 7.56985 5.66848 7.99454L4.57431 9.25135C4.37824 9.4766 4.2802 9.58919 4.27124 9.72994C4.26228 9.87069 4.34263 9.99094 4.50333 10.2314C5.87299 12.2806 7.71894 14.1272 9.76983 15.498C10.0103 15.6587 10.1305 15.739 10.2712 15.7301C10.412 15.7211 10.5247 15.6231 10.7498 15.427L12.0067 14.3328C12.4314 13.963 12.7888 13.6519 13.1098 13.4302C13.4502 13.195 13.799 13.0245 14.2151 12.9811C14.6312 12.9377 15.0077 13.0327 15.3893 13.1925C15.7491 13.3432 16.163 13.5739 16.6547 13.848L17.9902 14.5924C18.4094 14.8261 18.7267 15.2022 18.8243 15.6744C18.9229 16.1515 18.7775 16.6312 18.4562 17.0254C17.2904 18.4557 15.4227 19.3664 13.4633 18.9711C12.259 18.7282 11.0707 18.3234 9.63342 17.4992C6.74558 15.843 4.15636 13.2524 2.50212 10.3679C1.67786 8.9306 1.2731 7.74232 1.03015 6.53794C0.634898 4.57858 1.54559 2.71085 2.9759 1.5451C3.37009 1.22381 3.84971 1.07834 4.32688 1.17695Z" fill="white" />
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3045 1.54C11.432 1.0978 11.894 0.842779 12.3362 0.970388C15.559 1.90041 18.0973 4.43862 19.0275 7.66132C19.155 8.1035 18.9 8.56545 18.4579 8.69304C18.0157 8.8207 17.5537 8.5657 17.4261 8.1235C16.6548 5.45101 14.5466 3.34295 11.874 2.57171C11.4319 2.4441 11.1769 1.98219 11.3045 1.54ZM10.793 5.47187C10.973 5.04825 11.4622 4.85066 11.8859 5.03055C13.2706 5.6186 14.3793 6.72725 14.9673 8.11199C15.1472 8.53562 14.9496 9.02487 14.526 9.20479C14.1024 9.38462 13.6131 9.18704 13.4332 8.76345C13.014 7.77614 12.2217 6.9839 11.2344 6.56463C10.8108 6.38474 10.6132 5.8955 10.793 5.47187Z" fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_5832_90599">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg> (0) 755 260852</a>
                    </div>

                    <br />

                    <a href="https://wa.me/256755260852" class="vl-btn4">WhatsApp<span><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM10 7C9.5955 7 9.2309 7.24364 9.0761 7.61732C8.92134 7.99099 9.0069 8.42111 9.2929 8.70711L10.5858 10L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L12 11.4142L13.2929 12.7071C13.5789 12.9931 14.009 13.0787 14.3827 12.9239C14.7564 12.7691 15 12.4045 15 12V8C15 7.44772 14.5523 7 14 7H10Z" fill="white" />
                    </svg></span></a>
                  </div>


                </div>

                <div class="space20"></div>
                <div class="vl-offcanvas-info">
                  <h3 class="vl-offcanvas-sm-title">Contact Us</h3>
                  <div class="space20"></div>
                  <span><a href="#"> <i class="fa-solid fa-phone"></i> +256755260852</a></span>
                  <span><a href="#"><i class="fa-regular fa-envelope"></i> info@ntindamedic.com</a></span>
                  <span><a href="#"><i class="fa-solid fa-location-dot"></i> Ntinda Stretcher Road</a></span>
                </div>
                <div class="space20"></div>
                <div class="vl-offcanvas-social">
                  <h3 class="vl-offcanvas-sm-title">Follow Us</h3>
                  <div class="space20"></div>
                  <a href="#"><i class="fab fa-facebook-f"></i></a>
                  <a href="#"><i class="fab fa-twitter"></i></a>
                  <a href="#"><i class="fab fa-linkedin-in"></i></a>
                  <a href="#"><i class="fab fa-instagram"></i></a>
                </div>

              </div>
            </div>
            <div class="vl-offcanvas-overlay"></div>
          </div>

          <div class="inner-header-section-area" style={{ backgroundImage: `url(assets/img/all-images/bg/bg9.png)`, backgroundPosition: 'center top', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
            {/* style="background-image: url(assets/img/all-images/bg/bg9.png); background-position: center; background-repeat: no-repeat; background-size: cover;" */}
            <img src="assets/img/elements/elements28.png" alt="" class="elements28" />
            <div class="container">
              <div class="row align-items-center">
                <div class="col-lg-12">
                  <div class="hero-header">
                    <h1 class="text-anime-style-1">Gallery</h1>
                    <div class="space28"></div>
                    <a href="/" class="bradecrumb">Home <i class="fa-solid fa-angle-right"></i> Gallery</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {<Footer />}
        </body>
      </>
    )
  }
}
export default Contact